// Soliss Industries — official product catalogue
// Specs sourced from manufacturer datasheet.

export const PRODUCTS = [
  {
    code: "SOL_S23",
    name: "S23 Slimline",
    category: "Slimline Sliding System",
    system: "System Aluminium",
    tagline: "Glass that disappears, view that doesn't.",
    image: "/products/sol-s23-slimline.jpg",
    description:
      "Floor-to-ceiling slimline sliding doors with a 23 mm centre sightline. Built for large openings where the architecture is the view — and the frame should not interrupt it.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "1500 mm" },
      { label: "Max sash height", value: "3000 mm" },
      { label: "Glass", value: "5–20 mm" },
      { label: "Max sash weight", value: "140 kg" },
      { label: "Sightline", value: "23 mm" },
    ],
    features: [
      "Stainless steel running gear",
      "Lift-and-slide hardware option",
      "Hidden frame head & sill",
      "Configurations: 2 / 3 / 4 / 6 panels",
    ],
  },
  {
    code: "SOL_S28",
    name: "S28 Slimline",
    category: "Slimline Sliding System",
    system: "System Aluminium",
    tagline: "A quiet doorway into the garden.",
    image: "/products/sol-s28-real.jpg",
    description:
      "Slimline sliding door with a 28 mm sightline — engineered for unbroken sightlines between living space and garden. Thermally broken aluminium frame with a low, near-flush threshold.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "1000 mm" },
      { label: "Max sash height", value: "2400 mm" },
      { label: "Glass", value: "5–20 mm" },
      { label: "Max sash weight", value: "80 kg" },
      { label: "Sightline", value: "28 mm" },
    ],
    features: [
      "Concealed multi-point locking",
      "Soft-close mechanism",
      "RAL-matched anthracite finish",
      "Low-rise flush threshold option",
    ],
  },
  {
    code: "SOL_S15",
    name: "S15 Minimal",
    category: "Slimline Sliding System",
    system: "System Aluminium",
    tagline: "Effortless on the hand. Honest on the eye.",
    image: "/products/sol-s15-minimal.jpg",
    description:
      "Our slimmest sliding section — a 15 mm sightline lift-and-slide door engineered for terraces and indoor–outdoor rooms where the eye should meet glass, not metal.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "1500 mm" },
      { label: "Max sash height", value: "2400 mm" },
      { label: "Glass", value: "5–20 mm" },
      { label: "Max sash weight", value: "120 kg" },
      { label: "Sightline", value: "15 mm" },
    ],
    features: [
      "Single-finger lift-and-slide operation",
      "Bronze, anthracite & graphite finishes",
      "Smart-lock compatible",
      "Insect screen integration",
    ],
  },
  {
    code: "SOL_G8",
    name: "G8 Casement",
    category: "Casement Window",
    system: "System Aluminium",
    tagline: "The window, refined down to its hinges.",
    image: "/products/sol-g8.jpg",
    description:
      "A precision-milled aluminium casement window with concealed hinges. Designed for daily use over decades — not seasons.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "900 mm" },
      { label: "Max sash height", value: "1800 mm" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Max sash weight", value: "70 kg" },
    ],
    features: [
      "Well-engineered hardware & hinges",
      "Burglar-resistant RC2 standard",
      "Acoustic glass option",
      "Hidden drainage channels",
    ],
  },
  {
    code: "SOL_V10",
    name: "V10 Casement",
    category: "Casement Door / Tall Window",
    system: "System Aluminium",
    tagline: "An open door to the horizon.",
    image: "/products/sol-v10.jpg",
    description:
      "A taller, heavier casement system for balconies, terraces and rooflines — same precision hinge platform as the G8, scaled for full-height openings.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "1200 mm" },
      { label: "Max sash height", value: "3000 mm" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Max sash weight", value: "90 kg" },
    ],
    features: [
      "Single or double leaf",
      "Outward or inward opening",
      "Flush threshold option",
      "Salt-air resistant for coastal builds",
    ],
  },
  {
    code: "SOL_SF",
    name: "Sliding Folding",
    category: "Bifold Sliding-Folding Door",
    system: "System Aluminium",
    tagline: "Open the whole wall — without losing it.",
    image: "/products/sol-folding.jpg",
    description:
      "Multi-panel folding wall that stacks flush into a side pocket. The Sliding Folding system turns an entire wall into an opening and back again in a single stroke.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Max sash width", value: "1000 mm" },
      { label: "Max sash height", value: "3000 mm" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Max sash weight", value: "120 kg" },
      { label: "Sightline", value: "66 mm" },
    ],
    features: [
      "95% opening to your living",
      "Single-handle operation across the full run",
      "Walk-through traffic panel option",
      "Integrated drainage at sill",
    ],
  },
  {
    code: "SOL_CS",
    name: "Curve Sliding",
    category: "Bespoke Curved Slider",
    system: "System Aluminium",
    tagline: "Drawn by the room. Built by the atelier.",
    image: "/products/sol-cs-curve.jpg",
    bespoke: true,
    description:
      "A curved-track sliding system, drawn and engineered to the specific radius of the building. Made-to-design — there is no catalogue page, only your plans and our shop floor.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Dimensions", value: "As per design" },
      { label: "Glass", value: "Specified per project" },
      { label: "Lead time", value: "12–16 weeks" },
    ],
    features: [
      "CNC-milled curved tracks",
      "Bespoke radius and arc length",
      "Single, double or concentric curves",
      "Engineered alongside your architect",
    ],
  },
  {
    code: "SOL_U7",
    name: "U7 Premium uPVC",
    category: "Premium uPVC Sections",
    system: "uPVC",
    tagline: "Quiet performance. Honest finish.",
    image: "/products/sol-u7-upvc.jpg",
    description:
      "Premium uPVC sections engineered for thermal comfort and low-maintenance living. Available in white, cream and foiled woodgrain finishes — paired with the same multi-point locking platform as our aluminium systems.",
    specs: [
      { label: "System", value: "uPVC" },
      { label: "Max sash width", value: "1000 mm" },
      { label: "Max sash height", value: "2700 mm" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Max sash weight", value: "150 kg" },
    ],
    features: [
      "Multi-chamber thermal sections",
      "Galvanised steel reinforcement",
      "White · Cream · Foiled woodgrain finishes",
      "Well-engineered multi-point locking",
    ],
  },
  {
    code: "SOL_TT",
    name: "Tilt & Turn",
    category: "Multi-mode Casement Window",
    system: "System Aluminium",
    tagline: "One sash. Three rooms it can be.",
    image: "/products/sol-tt-tilt-turn.jpg",
    description:
      "A single sash that closes flush, tilts inward for trickle ventilation, or fully turns open for cleaning and airflow. The default European window — engineered on our 78 mm aluminium frame.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Operation", value: "Closed · Tilt · Turn · Locked" },
      { label: "Frame depth", value: "78 mm" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Hardware", value: "Well-engineered multi-point" },
    ],
    features: [
      "Concealed hinges & locking mech",
      "Child-safe restricted opening",
      "Compatible with G8 and V10 frames",
      "Acoustic glass and security upgrades",
    ],
  },
  {
    code: "SOL_GB",
    name: "Georgian Bar",
    category: "Heritage Grid Door & Window",
    system: "System Aluminium",
    tagline: "An old shape, drawn on a new line.",
    image: "/products/sol-gb-georgian.jpg",
    description:
      "Slim aluminium mullions arranged in a Georgian grid — the proportion of a traditional steel-frame door, built in thermally broken aluminium with modern weather sealing. Fixed sidelights and matching transoms available.",
    specs: [
      { label: "System", value: "Aluminium" },
      { label: "Bar width", value: "20 mm (slim) / 32 mm (classic)" },
      { label: "Grid", value: "2×3, 3×3, 3×4 or bespoke" },
      { label: "Glass", value: "5–24 mm" },
      { label: "Frame", value: "Matte black, anthracite or RAL" },
    ],
    features: [
      "True divided lights or applied bars",
      "Matched fixed sidelights & transoms",
      "Heritage-style D-handle option",
      "Indoor or outdoor application",
    ],
  },
];

export const PRODUCT_BY_CODE = Object.fromEntries(PRODUCTS.map((p) => [p.code, p]));
